<template>
<v-card>
    <v-card-title class="subtitle-1">
        <v-icon color="amber lighten-2" class="mr-3">mdi-bell-ring</v-icon>공지사항
        <v-spacer />
        <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on }">
                <v-btn bottom color="accent" dark small @click="create">
                    <v-icon small class="mr-2">mdi-plus</v-icon>
                    글쓰기
                </v-btn>
            </template>
            <v-card v-if="dialog">
                <v-card-title>
                    <span v-if="!editItem._id" class="subtitle-1">공지사항 등록</span>
                    <span v-else class="subtitle-1">공지사항 수정</span>
                </v-card-title>
                <v-card-text>
                    <v-text-field v-model="editItem.subject" label="제목" placeholder=" " hide-details></v-text-field>
                    <v-textarea v-model="editItem.content" label="내용" placeholder=" " hide-details class="mt-4"></v-textarea>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="close">취소</v-btn>
                    <v-btn color="primary" text @click="save">저장</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card-title>
    <v-card-text class="pa-0">
        <v-divider />
        <v-data-table :headers="notificationsHeaders" :items="notifications" disable-sort disable-pagination hide-default-footer>
            <template v-slot:item.notification="{ item }">
                <v-row @click="$set(item, 'show', !item.show)">
                    <v-col cols="auto" class="text-start">{{ item.subject }}</v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="auto">
                        <v-icon v-if="!item.show">mdi-chevron-down</v-icon>
                        <v-icon v-else>mdi-chevron-up</v-icon>
                    </v-col>
                </v-row>
                <v-expand-transition>
                    <v-row v-show="item.show">
                        <v-col>
                            <v-textarea v-model="item.content" readonly text hide-details class="text-body-1"></v-textarea>
                        </v-col>
                    </v-row>
                </v-expand-transition>
            </template>
            <template v-slot:item.createDate="{ item }">
                {{ item.createDate.toDate() }}
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon small @click="edit(item)">mdi-pencil</v-icon>
                <v-icon small @click="remove(item)" class="ml-2">mdi-delete</v-icon>
            </template>
        </v-data-table>

    </v-card-text>
</v-card>
</template>

<script>
import api from "@/api";
export default {
    data() {
        return {
            dialog: false,

            notifications: [],
            notificationsHeaders: [{
                    text: '공지사항',
                    align: 'center',
                    value: 'notification'
                },
                {
                    text: '작성일자',
                    align: 'center',
                    width: 170,
                    value: 'createDate'
                },
                {
                    text: 'Actions',
                    align: 'center',
                    width: 96,
                    value: 'actions'
                }
            ],

            editItem: null,
            defaultItem: {
                subject: null,
                content: null
            }
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.search();
        },
        async search() {
            try {
                var {
                    notifications
                } = await api.console.center.notifications.getNotifications({
                    headers: {
                        skip: 0,
                        limit: 5,
                    }
                });

                this.notifications = notifications;
            } catch (error) {
                console.error(error);
            }
        },
        close(){
            this.dialog = false;
        },
        create(){
            this.editItem = Object.assign({}, this.defaultItem);
            this.dialog = true;
        },
        edit(notification){
            this.editItem = Object.assign({}, notification);
            this.dialog = true;
        },
        async save(){
            try{
                this.editItem._id ? await api.console.center.notifications.putNotification(this.editItem) : await api.console.center.notifications.postNotification(this.editItem);
                await this.search();
                alert("저장되었습니다");
                this.dialog = false;
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
        async remove(notification){
            try{
                if(confirm("공지사항을 삭제하시겠습니까?")){
                    await api.console.center.notifications.deleteNotification(notification);
                    await this.search();
                }
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
    }
}
</script>
